export default "__VITE_ASSET__YoLoplys__"